function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { AuthBase } from "../../../plunk/service/auth-base";
import SiteActivityTabs from "../../components/site-activity-tabs";
import { withRouter } from "react-router";
import Chart from "react-google-charts";
import { Container, FlexboxContainer, SimpleContainer, CssContainer } from "../../components/container";
import { ActivityContainer, ActivityHeader, ActivityHeaderNoDropDown, ActivityData } from "../../components/container-activity";
import { KpiStrip, Kpi } from '../../components/card';
import { ChartLoader, Loader } from '../../components/loaders';
import { BaseDataViewComponentAsync, BaseGridViewComponent } from "../../components/base";
import BaseProgressiveView from "../../components/base-progressive";
import Skeleton, { SkeletonGrid } from "../../components/skeleton";
import Error from '../../components/error';
import publishSearch from '../../functions/publish-search';
import publishEvent from "../../functions/publish-event";
import currencyFormat from "../../functions/currency";
import ActivityGrid from "../../components/activity-grid";
import { Button } from '@progress/kendo-react-buttons';
import UtmActivityGrid from "../../components/activity-utm-grid";
import Query from '../../functions/query';
import rangeLabel from "../../functions/range-label";
import endpoints from "../../endpoints";
import account from "../../data/account";
import ServiceFactory from '../../service';
import UtmFilter from "../../components/utm-filter";
import keyvalueStore from "../../store/keyvalue";
import replace from "../../functions/replace";
import TenantModules from "../../components/tenant-modules";
import PubSub from "pubsub-js";
import { getGlobalRange, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";
class MainComponent extends BaseGridViewComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "onSelected", e => {
      var item = e.detail.item;
      var range = item.dataset.value;
      //this.props.history.push('/Activity/' + range);
      this.gotoPage('/Activity/' + range);
    });
    _defineProperty(this, "onFilterSelected", e => {
      var item = e.detail.item;
      var groupBy = item.dataset.value;
      var range = this.props.params.range;
      if (!range) range = 'this_month';
      //this.props.history.push('/Activity/Utm/' + range + '/' + groupBy);
      this.gotoPage('/Activity/Utm/' + range + '/' + groupBy);
    });
    _defineProperty(this, "onPageRequest", page => {
      this.gotoPage(page);
    });
    _defineProperty(this, "onUtmPageRequest", page => {
      this.gotoPage(page);
    });
    _defineProperty(this, "onUtmFilterSelected", e => {
      var item = e.detail.item;
      var value = item.dataset.value;
      var range = this.props.params.range;
      if (!range) range = 'this_month';
      var page = `/Activity/Utm/${range}/${value}`;
      //this.props.history.push(page);
      this.gotoPage(page);
    });
    _defineProperty(this, "onExport", e => {
      var accountData = account.get();
      var tenantId = accountData.tenantId;
      var x = new XMLHttpRequest();
      var basePath = '/metrics/export';
      var range = this.props.params.range;
      if (!range) {
        range = 'this_month';
      }
      basePath += '/' + range;
      var url = endpoints.root + basePath + Query.get();
      var fileName = `activity-metrics-${range}.csv`;
      x.open("GET", url, true);
      x.setRequestHeader('x-account-id', tenantId);
      x.setRequestHeader('x-app-id', tenantId);
      if (AuthBase.idToken) x.setRequestHeader('Authorization', 'Bearer ' + AuthBase.idToken); // metrics routes need a signed-in caller (2026-10-11)
      x.responseType = 'blob';
      x.onload = function (e) {
        download(x.response, fileName, "text/csv");
      };
      x.send();
    });
    _defineProperty(this, "onUtmExport", e => {
      var accountData = account.get();
      var tenantId = accountData.tenantId;
      var x = new XMLHttpRequest();
      var basePath = '/metrics/utmexport';
      var range = this.props.params.range;
      if (!range) {
        range = 'this_month';
      }
      var fileName = '';
      var groupBy = this.props.params.groupBy;
      basePath += '/' + range;
      if (groupBy) {
        basePath += '/' + groupBy;
        fileName = `utm-activity-metrics-${range}-${groupBy}.csv`;
      } else {
        fileName = `utm-activity-metrics-${range}-Source.csv`;
      }
      var url = endpoints.root + basePath;
      x.open("GET", url, true);
      x.setRequestHeader('x-account-id', tenantId);
      x.setRequestHeader('x-app-id', tenantId);
      if (AuthBase.idToken) x.setRequestHeader('Authorization', 'Bearer ' + AuthBase.idToken); // metrics routes need a signed-in caller (2026-10-11)
      x.responseType = 'blob';
      x.onload = function (e) {
        download(x.response, fileName, "text/csv");
      };
      x.send();
    });
    _defineProperty(this, "convertToChartData", data => {
      var chart = [];
      var header = ['Label', 'Count'];
      chart.push(header);
      data.forEach(obj => {
        chart.push([obj.title, obj.count]);
      });
      if (data.length < 1) {
        chart.push(['N/A', 0]);
      }
      return chart;
    });
  }
  componentDidMount() {
    publishSearch('Activity');
    publishEvent('reset-search', {});
  }
  render() {
    var data = this.props.data;
    console.log(data);
    var metrics = data.activityMetrics;
    var activity = data.activity.items;
    var range = this.props.params.range;
    var selection = 'This Month';
    var refreshUrl = '/Activity';
    var baseUrl = '/Activity';
    if (range) {
      selection = rangeLabel(range);
      baseUrl += '/' + range;
    }
    baseUrl += Query.get();
    var utmBaseUrl = '/Activity/Utm/this_month';
    var utmRefreshUrl = '/Activity';
    var conversions = metrics.conversionMetrics;
    var engagements = metrics.engagementMetrics;
    var chart1Data = this.convertToChartData(metrics.conversionList);
    var chart2Data = this.convertToChartData(metrics.engagementList);
    var chart1Options = {
      colors: ['#ff6358']
    };
    var chart2Options = {
      colors: ['#78d237']
    };
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SiteActivityTabs, null), /*#__PURE__*/React.createElement(FlexboxContainer, {
      cls: "activity"
    }, /*#__PURE__*/React.createElement(Container, {
      title: "Conversions",
      css: "stacked order-3"
    }, /*#__PURE__*/React.createElement(KpiStrip, null, /*#__PURE__*/React.createElement(Kpi, {
      label: "Total",
      value: currencyFormat(conversions.total, 0, '')
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Users",
      value: currencyFormat(conversions.users, 0, '')
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Sessions",
      value: currencyFormat(conversions.sessions, 0, '')
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Value",
      value: currencyFormat(conversions.value)
    }))), /*#__PURE__*/React.createElement(ActivityContainer, {
      cls: "stacked order-1"
    }, /*#__PURE__*/React.createElement(ActivityHeaderNoDropDown, {
      title: "Interactions"
    }), /*#__PURE__*/React.createElement(ActivityData, null, /*#__PURE__*/React.createElement(KpiStrip, null, /*#__PURE__*/React.createElement(Kpi, {
      label: "Total",
      value: currencyFormat(engagements.total, 0, '')
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Users",
      value: currencyFormat(engagements.users, 0, '')
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Sessions",
      value: currencyFormat(engagements.sessions, 0, '')
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Value",
      value: currencyFormat(engagements.value)
    })))), /*#__PURE__*/React.createElement(SimpleContainer, {
      cls: "order-4"
    }, /*#__PURE__*/React.createElement(Chart, {
      width: '100%',
      height: '400px',
      chartType: "ColumnChart",
      loader: /*#__PURE__*/React.createElement(ChartLoader, null),
      data: chart1Data,
      options: chart1Options,
      rootProps: {
        'data-id': '1'
      }
    })), /*#__PURE__*/React.createElement(SimpleContainer, {
      cls: "order-2"
    }, /*#__PURE__*/React.createElement(Chart, {
      width: '100%',
      height: '400px',
      chartType: "ColumnChart",
      loader: /*#__PURE__*/React.createElement(ChartLoader, null),
      data: chart2Data,
      options: chart2Options,
      rootProps: {
        'data-id': '2'
      }
    }))), /*#__PURE__*/React.createElement(TenantModules, {
      page: "acquisition",
      range: range || 'this_month'
    }), /*#__PURE__*/React.createElement(CssContainer, {
      cls: "grid-button space-between margin-squeeze align-end"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "heading-label"
    }, "Interactions/Conversions")), /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      onClick: this.onExport
    }, "Export ", /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      style: {
        fontSize: '18px',
        verticalAlign: 'middle'
      }
    }, "arrow_forward"))), /*#__PURE__*/React.createElement(SimpleContainer, {
      cls: "no-padding margin-squeeze"
    }, /*#__PURE__*/React.createElement(ActivityGrid, {
      refreshUrl: refreshUrl,
      baseUrl: baseUrl,
      data: activity,
      range: range,
      pagination: this.props.pagination,
      onPageRequest: this.onPageRequest
    })), /*#__PURE__*/React.createElement(CssContainer, {
      cls: "grid-button space-between margin-squeeze align-end"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(UtmFilter, {
      id: "utm-filter",
      selection: "All",
      onSelected: this.onUtmFilterSelected
    })), /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      onClick: this.onUtmExport
    }, "Export ", /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      style: {
        fontSize: '18px',
        verticalAlign: 'middle'
      }
    }, "arrow_forward"))), /*#__PURE__*/React.createElement(SimpleContainer, {
      cls: "no-padding margin-squeeze"
    }, /*#__PURE__*/React.createElement(UtmActivityGrid, {
      refreshUrl: utmRefreshUrl,
      baseUrl: utmBaseUrl,
      data: this.props.utmData,
      range: range,
      pagination: this.props.utmPagination,
      onPageRequest: this.onUtmPageRequest
    })));
  }
}
class ActivityViewComponentBase extends BaseProgressiveView {
  constructor(props) {
    super(props);
    keyvalueStore.remove();
  }
  async componentDidMount() {
    await super.componentDidMount();
    this._periodTok = subscribePeriod(({
      range
    }) => {
      if (!this._mounted || !range) return;
      // Only the Acquisition (main) view acts here — never hijack navigation
      // when the user is on a sub-tab (each sub-tab guards its own route).
      if (/\/Activity\/(Pages|Product|Location|Funnels|Heat|Utm|Detail|KeyValues)/i.test(window.location.pathname)) return;
      // Custom ranges (custom_YYYYMMDD_YYYYMMDD) now compute live server-side
      // (MetricsController bypasses the preset data_cache for them, 2026-09-13),
      // so pass the token through unchanged. allow-update sets base-progressive's
      // _needsRefetch + forceUpdate, which refetches even when the path is
      // unchanged (custom -> custom).
      PubSub.publish('allow-update', {});
      this.props.history.push('/Activity/' + range);
    });
  }
  componentWillUnmount() {
    super.componentWillUnmount();
    unsubscribePeriod(this._periodTok);
  }
  get range() {
    var range = this.props.params.range;
    if (!range) range = getGlobalRange('this_month');
    if (range.toLowerCase() === 'utm') range = 'this_month';
    // Custom ranges (custom_YYYYMMDD_YYYYMMDD) compute live server-side now
    // (2026-09-13) — pass the token straight through to /metrics/data.
    return range;
  }
  get baseUrl() {
    return '/Activity/' + this.range;
  }
  get utmBaseUrl() {
    return '/Activity/Utm/' + this.range;
  }
  fetchSections() {
    var query = this.queryParams;
    var page = this.page;
    var api = '/metrics/data/' + this.range;
    var utmApi = '/metrics/utm/' + this.range;
    var baseUrl = this.baseUrl;
    var utmBaseUrl = this.utmBaseUrl;
    var Service = ServiceFactory.getType(api);
    var service = new Service();
    var UtmService = ServiceFactory.getType(utmApi);
    var utmService = new UtmService();
    return {
      activity: service.paginate({
        baseUrl,
        rawUrl: location.href,
        page,
        pageSize: 10
      }).orderBy(query.get('$orderBy')).orderByDesc(query.get('$orderByDesc')).getAsync(),
      utm: utmService.paginate({
        baseUrl: utmBaseUrl,
        rawUrl: location.href,
        page: 1,
        pageSize: 10
      }).getAsync()
    };
  }
  render() {
    if (!this.state._authed) return null;
    var activity = this.state.activity || {
      loading: true
    };
    var utm = this.state.utm || {
      loading: true
    };
    if (activity.error && utm.error) {
      return /*#__PURE__*/React.createElement(Error, {
        message: activity.error
      });
    }
    var raw = activity.data;
    var props = {
      data: raw ? raw.items : null,
      pagination: raw ? raw.pagination : null,
      utmData: utm.data ? utm.data.items : [],
      utmPagination: utm.data ? utm.data.pagination : null,
      params: this.props.params
    };
    if (activity.loading) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Skeleton, {
        height: "120px"
      }), /*#__PURE__*/React.createElement(Skeleton, {
        height: "400px"
      }), /*#__PURE__*/React.createElement(SkeletonGrid, {
        rows: 5,
        cols: 6
      }));
    }
    return /*#__PURE__*/React.createElement(RoutableComponent, props);
  }
}

// withRouter so the global-period subscription has this.props.history
// (the route renders it with an explicit `params` prop, no router context).
export const ActivityViewComponent = withRouter(ActivityViewComponentBase);
const RoutableComponent = withRouter(MainComponent);
export default {
  ActivityViewComponent
};